/**
 * @ngdoc directive
 * @name flowCommentsCount
 * @module flowingly.runner.directives
 * @description This component is used to display a flow comments count.
 * @usage
 * ```
     <flow-comment-count commentCount="$ctrl.flow.commentCount" ></flow-comment-count>
 * ``` 
 */

import angular from 'angular';
import FlowCommentCountBridge from './FlowCommentCountBridge';

angular
  .module('flowingly.runner.directives')
  .component('flowCommentCount', FlowCommentCountBridge);
